import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Phone, MapPin, ArrowRight } from 'lucide-react';

export const LonavalaThankYouPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-20">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-10 max-w-lg w-full text-center">
        <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
        <h1 className="text-3xl font-extrabold text-gray-900 mb-3">Thank You!</h1>
        <p className="text-gray-600 text-lg mb-8">
          Our team will contact you shortly regarding your Lonavala investment inquiry.
        </p>

        <div className="space-y-4 mb-8 text-left">
          <div className="flex items-center gap-4 p-4 bg-red-50 rounded-xl">
            <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Phone className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Call for Details</p>
              <a
                href="tel:+919867300996"
                className="text-lg font-bold text-gray-900 hover:text-red-600 transition-colors"
              >
                +919867300996
              </a>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 bg-red-50 rounded-xl">
            <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <MapPin className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Location</p>
              <p className="text-lg font-bold text-gray-900">Lonavala, Maharashtra</p>
            </div>
          </div>
        </div>

        <Link
          to="/lonavala"
          className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
        >
          Back to Lonavala <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
